import React from 'react';
import { useSelector } from 'react-redux';
import AccountSearch from './components/AccountSearch/AccountSearch';
import AccountDetail from './components/AccountDetail/AccountDetail';

const ManageCustomerAccount = () => {
	const customerAccount = useSelector((state) => state.get('customerAccount'));
	const accountId = customerAccount.get('accountId');

	return !accountId ? <AccountSearch /> : <AccountDetail />;
};

export default ManageCustomerAccount;
